import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["ownerTwo"]

  connect() {
    this.toggle()
    this.element.addEventListener("input", this.handleInput)
  }

  disconnect() {
    this.element.removeEventListener("input", this.handleInput)
  }

  handleInput = (event) => {
    if (event.target.name && event.target.name.includes("owner1") && event.target.name.includes("ownership_percentage")) {
      this.toggle()
    }
  }

  toggle() {
    const percentageField = this.element.querySelector("input[name*='owner1'][name*='ownership_percentage']")
    const ownerTwoSection = this.ownerTwoTarget

    if (!percentageField || !ownerTwoSection) return

    const value = parseFloat(percentageField.value)
    const shouldShow = !isNaN(value) && value < 75

    ownerTwoSection.classList.toggle("hidden", !shouldShow)
  }
}
